import React, { useContext } from 'react'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import ThreeOptions from '../ThreeOptions'
import StepCounter from '../StepCounter'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import gif12 from './assets/13_cloud 2.gif'
import jpg12 from './assets/static/13_cloud-2.jpg'

import '../Gif.css'
import Gif from '../../components/Gif'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q12() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()

    return (
        <>
        <div className="picHold">

            <img className="gif12" src={settings.isAnimationPause ? jpg12 : gif12} />
        </div>
            <Headling text={translate('More or Less')} />
            <Subtitle text={translate('How much do I think the bank charges me every month?')} />
            <ThreeOptions 
                option1={translate('NIS 0-30 per month')}
                option2={translate('NIS 30-100 per month')}
                option3={translate('Over NIS 100 per month')} 
                onOption1Press={() => {
                    setNewAnswer({ 12:  1 } )
                    history.push('/CulcRes')
                    ReactPixel.trackCustom('cost_0_to_30', '');
                }}
                onOption2Press={() => {
                    setNewAnswer({ 12:  2 } )
                    history.push('/CulcRes')
                    ReactPixel.trackCustom('cost_30_to_100', '');
                }}
                onOption3Press={() => {
                    setNewAnswer({ 12:  3 } )
                    history.push('/CulcRes')
                    ReactPixel.trackCustom('cost_more_100', '');
                }}
                
                />
            <StepCounter />

        </>
    )
}



export default Q12

